export function normalizeMovementType(type) {
  return `${type || 'redeem'}`.toLowerCase();
}

export function hasExplicitTime(value) {
  return typeof value === 'string' && /[T\s]\d{2}:\d{2}/.test(value.trim());
}

export function isMidnightPlaceholder(value) {
  if (typeof value !== 'string') {
    return false;
  }

  const normalized = value.trim();
  return /[T\s]00:00(?::00(?:\.000)?)?(?:Z|[+-]\d{2}:\d{2})?$/.test(normalized);
}

export function getMovementTypeLabel(type) {
  const normalizedType = normalizeMovementType(type);

  switch (normalizedType) {
    case 'redeem':
      return 'Canje';
    case 'adjust':
      return 'Ajuste';
    case 'issue':
      return 'Alta';
    case 'info_update':
      return 'Edición de datos';
    default:
      return normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1);
  }
}

export function hydrateIssueMovementTimes(movements, fallbackPerformedAt) {
  return (movements || []).map((movement) => {
    if (normalizeMovementType(movement.type) !== 'issue') {
      return movement;
    }

    if (hasExplicitTime(movement.performedAt) && !isMidnightPlaceholder(movement.performedAt)) {
      return movement;
    }

    return {
      ...movement,
      performedAt: fallbackPerformedAt || movement.performedAt,
    };
  });
}
